import { Html5Qrcode } from "html5-qrcode";
import { useEffect, useRef } from "react";

const QRCodeReader = (props: any) => {
  // https://scanapp.org/html5-qrcode-docs/docs/intro
  const qrCodeRef = useRef<HTMLDivElement>(null);
  const html5QrCodeRef = useRef<Html5Qrcode | null>(null);

  useEffect(() => {
    if (!qrCodeRef.current) {
      return;
    }

    html5QrCodeRef.current = new Html5Qrcode(qrCodeRef.current?.id || "");

    html5QrCodeRef.current
      .start(
        { facingMode: "environment" },
        {
          fps: 25,
          qrbox: 250,
        },
        (decodedText, decodedResult) => {
          console.log(`Code matched = ${decodedText}`, decodedResult);
          props.qrCodeSuccessCallback(decodedText);
        },
        (errorMessage) => {
          // parse error, ignore it.
        },
      )
      .then(() => {
         const video = qrCodeRef.current?.querySelector("video");
         console.log(video)
   
        if (video) {
          video.setAttribute('autoplay', '');
          video.setAttribute('muted', '');
          video.setAttribute('playsinline', '');
        }
      })
      .catch((err) => {
        // Start failed, handle it.
      });

    return () => {
      if (html5QrCodeRef.current?.isScanning) {
        html5QrCodeRef.current
          .stop()
          .then(() => {
            html5QrCodeRef.current?.clear();
          })
          .catch((err) => {
            // Stop failed, handle it.
          });
      }
    };
  }, [props]);

  return (
    <div
      ref={qrCodeRef}
      id="html5qr-code-full-region"
    />
  );
};

export default QRCodeReader;
